(() => {
  const formatPrice = value => '$' + new Intl.NumberFormat('es-CL', {maximumFractionDigits: 0}).format(Number(value));
  function init() {
    document.querySelectorAll('[data-dnc-header]:not([data-dnc-ready])').forEach(header => {
      header.dataset.dncReady = 'true';
      const wrap = header.querySelector('[data-dnc-search-wrap]');
      const input = wrap.querySelector('[data-dnc-search-input]');
      const results = wrap.querySelector('[data-dnc-results]');
      const status = wrap.querySelector('[data-dnc-status]');
      let timer, controller, lastQuery = '';
      const close = () => {results.hidden = true; input.setAttribute('aria-expanded', 'false');};
      const open = () => {if (wrap.contains(document.activeElement)) {results.hidden = false; input.setAttribute('aria-expanded', 'true');}};
      const message = (text, loading = false) => {
        results.replaceChildren();
        const p = document.createElement('p'); p.className = 'dnc-search-message' + (loading ? ' dnc-search-loading' : ''); p.textContent = text; results.append(p);
        status.textContent = text; open();
      };
      const allResults = query => {
        const link = document.createElement('a'); link.className = 'dnc-search-all'; link.setAttribute('role', 'option');
        link.href = (window.Shopify?.routes?.root || '/') + 'search?' + new URLSearchParams({q: query, type: 'product', 'options[prefix]': 'last'});
        link.textContent = results.dataset.all; results.append(link);
      };
      input.addEventListener('input', () => {
        clearTimeout(timer); controller?.abort();
        const query = input.value.trim();
        if (query.length < 2) {lastQuery = ''; close(); status.textContent = ''; return;}
        timer = setTimeout(async () => {
          const request = new AbortController(); controller = request;
          message(results.dataset.loading, true);
          try {
            const params = new URLSearchParams({q: query, 'resources[type]': 'product', 'resources[limit]': '5', 'resources[options][unavailable_products]': 'last'});
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'search/suggest.json?' + params, {signal: request.signal});
            if (!response.ok) throw new Error('search');
            const data = await response.json();
            if (request.signal.aborted || input.value.trim() !== query) return;
            const products = data.resources?.results?.products || [];
            results.replaceChildren();
            for (const product of products) {
              const link = document.createElement('a'); link.className = 'dnc-suggestion'; link.href = product.url; link.setAttribute('role', 'option');
              const source = typeof product.image === 'string' ? product.image : product.featured_image?.url;
              if (source) {const image = document.createElement('img'); image.src = source; image.alt = ''; image.width = 48; image.height = 56; link.append(image);}
              const detail = document.createElement('span'); detail.textContent = product.title;
              if (product.price && Number.isFinite(Number(product.price))) {const price = document.createElement('strong'); price.textContent = formatPrice(product.price); detail.append(price);}
              link.append(detail); results.append(link);
            }
            if (!products.length) message(results.dataset.empty);
            allResults(query); lastQuery = query;
            status.textContent = products.length ? products.length + ' productos sugeridos' : results.dataset.empty;
            open();
          } catch (error) {
            if (error.name === 'AbortError' || input.value.trim() !== query) return;
            message(results.dataset.error); allResults(query);
          }
        }, 220);
      });
      input.addEventListener('focus', () => {if (lastQuery === input.value.trim() && results.children.length) open();});
      input.addEventListener('keydown', event => {
        if (event.key === 'Escape') close();
        if (event.key === 'ArrowDown' && !results.hidden) {event.preventDefault(); results.querySelector('a')?.focus();}
      });
      results.addEventListener('keydown', event => {
        const links = [...results.querySelectorAll('a')], index = links.indexOf(document.activeElement);
        if (event.key === 'Escape') {input.focus(); close();}
        if (event.key === 'ArrowDown' && links.length) {event.preventDefault(); links[(index + 1) % links.length]?.focus();}
        if (event.key === 'ArrowUp') {event.preventDefault(); if (index <= 0) input.focus(); else links[index - 1]?.focus();}
      });
      document.addEventListener('click', event => {if (!wrap.contains(event.target)) close();});
      wrap.addEventListener('focusout', () => setTimeout(() => {if (!wrap.contains(document.activeElement)) close();}, 0));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
